/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { assert } from "@ember/debug";
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { dateFormat } from "core/helpers/datepicker-format";
import { modifier } from "ember-modifier";
import $ from "jquery";
let FuiCalendarComponent = (_class = class FuiCalendarComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "currentValue", this.selected);
    _defineProperty(this, "setDateCalendar", modifier(this._setDateCalendar));
  }
  get placeholder() {
    switch (this.args.settings.type) {
      case "month":
        return "ex. : 01/2007";
      case "year":
        return "ex. : 2007";
      case "time":
        return "ex. : 12:00";
      default:
        return "ex. : 09/01/2017";
    }
  }
  get selected() {
    if (typeof this.args.selected == "string" && !isNaN(Date.parse(this.args.selected))) {
      return new Date(this.args.selected);
    }
    return this.args.selected;
  }
  _setDateCalendar(calendar) {
    assert("args.selected must be a date, a date string or undefined", this.selected instanceof Date || this.selected == undefined);
    $(calendar).calendar("set date", this.selected);
  }
  focusOut() {
    this.args.onFocusOut?.(this.currentValue);
  }
  onChange(value) {
    this.currentValue = value;
  }
  onShow() {
    return this.args.isReadOnly !== true;
  }
  get settings() {
    return Object.assign({}, {
      selectAdjacentDays: true,
      firstDayOfWeek: 1,
      monthFirst: false,
      text: {
        days: ["D", "L", "M", "Me", "J", "V", "S"],
        months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        monthsShort: ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
        today: "Aujourd'hui",
        now: "Maintenant"
      },
      onChange: this.onChange,
      onHide: this.focusOut,
      onShow: this.onShow,
      formatter: {
        date: dateFormat
      }
    }, this.args.settings);
  }
  get format() {
    return this.args.format || "default";
  }
}, _applyDecoratedDescriptor(_class.prototype, "_setDateCalendar", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setDateCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onShow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onShow"), _class.prototype), _class);
export { FuiCalendarComponent as default };